import { FC } from 'react';
import { State } from 'redux/initialState';
import { useSelector } from 'react-redux';

import DataTablePagination from 'modules/_shared/components/Tables/DataTablePagination';

import TableSkeleton from 'modules/_shared/components/Tables/TableSkeleton';
import DividendsTableHeader from './DividendsTableHeader';
import DividendsTableBody from './DividendsTableBody';
import { useDividendsDistributionModal } from '../context/DividendsDistributionModalContext';

const DividendsTable: FC = () => {
  const actualSociety = useSelector(
    (state: State) => state.society?.actualSociety
  );
  const { data, actions } = useDividendsDistributionModal();

  const totalItems =
    (actualSociety?.partnersCount?.active || 0) +
    (actualSociety?.partnersCount?.usufructuaries || 0);

  return (
    <>
      {data.isDividendsLoading ? (
        <TableSkeleton
          rows={9}
          columns={3}
          showSubHeader={false}
          cardInner={false}
          height={446}
        />
      ) : (
        <div
          className="card card-bordered card-preview"
          style={{ height: '446px' }}
        >
          <table
            className="table table-tranx"
            id="dividends-distribution-table"
          >
            <DividendsTableHeader />
            <DividendsTableBody />
          </table>
        </div>
      )}

      <DataTablePagination
        itemPerPage={data.rowsPerPage || 10}
        totalItems={totalItems || 0}
        paginate={actions.handleChangePage}
        currentPage={data.currentPage}
        onChangeRowsPerPage={actions.handleChangeRowsPerPage}
        customItemPerPage={0}
        setRowsPerPage={() => {}}
      />
    </>
  );
};

export default DividendsTable;
